<template>
  <div>
    <PlantillaLogin>
      <div slot="contenido">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

        <div
          class="columns is-centered"
          style="
            --eye-translate-x: 0%;
            --eye-rotate: 0deg;
            --eye-scale: 1;
            --eye-fill: #00698f;
          "
        >
          <article
            class="column card is-full-mobile is-two-thirds-tablet is-half-desktop form"
          >
            <form class="card-content" action v-on:submit.prevent="conectar">
              <h2 class="title has-text-primary">
                Servicio de Salud Magallanes
              </h2>
              <hr />

              <div class="field is-floating-label">
                <label for="username" class="label is-medium">RUT</label>
                <div class="control has-icons-left is-medium is-clearfix">
                  <input
                    autocomplete="on"
                    class="input is-medium data-hj-whitelist"
                    v-model="user.rut"
                    placeholder="Ejemplo: 18903182-3"
                    autofocus
                    required
                    v-on:keypress="isNumber($event)"
                  />
                  <span class="icon is-left">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="user-shield"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                      class="svg-inline--fa fa-user-shield fa-w-20"
                    >
                      <path
                        fill="currentColor"
                        d="M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                        class
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <div class="field is-floating-label">
                <label for="password" class="label is-medium"
                  >Fecha de nacimiento</label
                >
                <div
                  class="control has-icons-left has-icons-right is-medium is-clearfix"
                >
                  <b-input
                    type="password"
                    size="is-medium"
                    v-model="user.password"
                    placeholder="Ejemplo: 09/08/1994"
                    required                    
                    password-reveal
                    icon="lock"
                  >
                  </b-input>
                </div>
              </div>

              <div class="field">
                <p class="control">
                  <button
                    type="submit"
                    class="button is-medium is-info is-fullwidth"
                  >
                    <span>Ingresar</span>
                    <span class="icon is-small">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="sign-in-alt"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        class="svg-inline--fa fa-sign-in-alt fa-w-16 fa-xs"
                      >
                        <path
                          fill="currentColor"
                          d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                          class
                        />
                      </svg>
                    </span>
                  </button>
                </p>
                <b-message type="is-info" has-icon>
                  Para Ingresar favor de escribir su RUT <b>sin puntos y con guión</b> Ejemplo:
                  18903182-3, y su fecha de nacimiento con el siguiente formato,
                  si su cumpleaños fuese el 9 de agosto del 1994 sería así:
                  Ejemplo: 09/08/1994
                </b-message>
              </div>
            </form>
            <div class="field">
              <b-message type="is-danger" v-if="error">{{ error }}</b-message>
              <!-- <label class="checkbox"></label> -->
            </div>
          </article>
          <article
          style="display: flex; justify-content: center;"
            class="column card is-hidden-mobile is-on-thirds-tablet is-half-desktop back-img"
          >
            <!-- <img src="\images\covid.png" /> -->
            <div class="window">
              <div class="santa">
                <div class="head">
                  <div class="face">
                    <div class="redhat">
                      <div class="whitepart"></div>
                      <div class="redpart"></div>
                      <div class="hatball"></div>
                    </div>
                    <div class="eyes"></div>
                    <div class="beard">
                      <div class="nouse"></div>
                      <div class="mouth"></div>
                    </div>
                  </div>
                  <div class="ears"></div>
                </div>
                <div class="body"></div>
              </div>
            </div>
            <h4 style="align-self: flex-end;">
            <div class="estrellas has-text-centered">
              <span>E</span>
              <span>N</span>
              <span>C</span>
              <span>U</span>
              <span>E</span>
              <span>S</span>
              <span>T</span>
              <span>A</span>
              <span></span>
              <span>B</span>
              <span> <img src="/images/arbol.png" style="background-color:transparent;width:40%"/></span>
              <span>E</span>
              <span>N</span>
              <span>E</span>
              <span>S</span>
              <span>T</span>
              <span>A</span>
              <span>R</span>

            </div>
            
            </h4>
          </article>
        </div>
      </div>
    </PlantillaLogin>
  </div>
</template>
<script>
import PlantillaLogin from "../template/PlantillaLogin";
export default {
  name: "Login",
  components: {
    PlantillaLogin: PlantillaLogin,
  },
  data() {
    return {
      user: {
        rut: "",
        password: "",
        grant_type: "password",
        token: "",
        role_id: "",
      },
      error: "",
      isLoading: false,
    };
  },
  methods: {
    isNumber(evt) {
      console.log(evt);
      const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "k", "K","-"];
      const keyPressed = evt.key;
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },
    conectar: function () {
      this.error = "";
      this.isLoading = true;
      this.$http
        .post("api/auth", {
          rut: this.user.rut.toLowerCase(),
          password: this.user.password,
          grant_type: this.user.grant_type,
        })
        .then((response) => {
          console.log(response.body.user);
          this.user.token = response.body.token;
          window.localStorage.setItem(
            "token",
            (this.user.token = response.body.token)
          );
          window.localStorage.setItem(
            "userName",
            `${response.body.user.name} ${response.body.user.pather_lastname} ${response.body.user.mother_lastname}`
          );
          window.localStorage.setItem("perfil", response.body.user.role.type);
          window.localStorage.setItem(
            "user",
            JSON.stringify(response.data.user)
          );
          this.user.role_id = response.body.user.role_id;
          switch (this.user.role_id) {
            case 2:
              this.$router.push({ name: "administrativeHome" });
              this.isLoading = false;
              break;
            case 3:
              this.$router.push({ name: "questionary" });
              this.isLoading = false;
              break;
          }
          // if (this.user.role_id === 1) {
          //   this.$router.push(
          //     {
          //       name: "login",
          //     },
          //     () => {}
          //   );
          //   this.isLoading = false;
          // } else if (this.user.role_id === 2 ||this.user.role_id === 5 || this.user.role_id === 3 || this.user.role_id === 4) {
          //   this.$router.push({ name: "administrative"});
          //   this.isLoading = false;
          // }
        })
        .catch((response) => {
          this.isLoading = false;
          this.error = "Usuario y/o contraseña incorrecta";
          console.error(response);
        });
    },
  },
};
</script>

<style scoped>
.estrellas {
  position: relative;
  width: 520px;
  height:300px;
  margin: 0 auto;
  font-size: 70px;
  
}
.estrellas span {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 70px;
  height: 300px;
  margin-left: -35px;
  line-height: 480px; /* height*2 - font-size */
  text-align: center;
  transform-origin: top center;
}
.estrellas span:nth-of-type(1)  {
  transform: rotate(93deg);
}
.estrellas span:nth-of-type(2)  {
  transform: rotate(82deg);
}
.estrellas span:nth-of-type(3)  {
  transform: rotate(71deg);
}
.estrellas span:nth-of-type(4)  {
  transform: rotate(60deg);
}
.estrellas span:nth-of-type(5)  {
  transform: rotate(49deg);
}
.estrellas span:nth-of-type(6)  {
  transform: rotate(38deg);
}
.estrellas span:nth-of-type(7)  {
  transform: rotate(27deg);
}
.estrellas span:nth-of-type(8)  {
  transform: rotate(16deg);
}
.estrellas span:nth-of-type(9)  {
  transform: rotate(5deg);
}
.estrellas span:nth-of-type(10)  {
  transform: rotate(-5deg);
}
.estrellas span:nth-of-type(11)  {
  transform: rotate(-16deg);
}
.estrellas span:nth-of-type(12)  {
  transform: rotate(-27deg);
}
.estrellas span:nth-of-type(13)  {
  transform: rotate(-38deg);
}
.estrellas span:nth-of-type(14)  {
  transform: rotate(-49deg);
}
.estrellas span:nth-of-type(15)  {
  transform: rotate(-60deg);
}
.estrellas span:nth-of-type(16)  {
  transform: rotate(-71deg);
}
.estrellas span:nth-of-type(17)  {
  transform: rotate(-82deg);
}
.estrellas span:nth-of-type(18)  {
  transform: rotate(-93deg);
}
.estrellas span:nth-of-type(19)  {
  transform: rotate(-100deg);
}
.window {
  width: 340px;
  height: 340px;
  background: #a0d5d3;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  margin-top: -60px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border: 10px solid #f8e7dc;
  overflow: hidden;
}

.santa {
  position: absolute;
  left: 50%;
  bottom: 0;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
}
.santa .body {
  width: 190px;
  height: 210px;
  background: #de2f32;
  position: relative;
  border-radius: 50%;
  top: 0;
  -webkit-animation: bodyLaugh 4s linear infinite;
  -moz-animation: bodyLaugh 4s linear infinite;
  -ms-animation: bodyLaugh 4s linear infinite;
  -o-animation: bodyLaugh 4s linear infinite;
  animation: bodyLaugh 4s linear infinite;
  -webkit-transform: translateY(50%);
  -moz-transform: translateY(50%);
  -ms-transform: translateY(50%);
  -o-transform: translateY(50%);
  transform: translateY(50%);
}
.santa .body:before {
  content: " ";
  width: 7px;
  height: 7px;
  background: #f7be10;
  border-radius: 50%;
  position: absolute;
  top: 35%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px -18px 0px #f7be10, 0px 18px 0px #f7be10;
}
.santa .head {
  z-index: 2;
  position: absolute;
  bottom: 90px;
  left: 50%;
  -webkit-animation: headLaugh 4s linear infinite;
  -moz-animation: headLaugh 4s linear infinite;
  -ms-animation: headLaugh 4s linear infinite;
  -o-animation: headLaugh 4s linear infinite;
  animation: headLaugh 4s linear infinite;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
}
.santa .head .face {
  width: 120px;
  height: 130px;
  background: #edcab0;
  background: radial-gradient(#edcab0, #e9a982);
  border-radius: 50%;
  border: 3px solid #f8e7dc;
}
.santa .head .face .redhat .whitepart {
  position: absolute;
  left: 50%;
  top: 0;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 90%;
  height: 32px;
  background: #f8e7dc;
  border-radius: 50px;
  z-index: 4;
  box-shadow: 0px 6px 0px -4px rgba(0, 0, 0, 0.1);
}
.santa .head .face .redhat .redpart {
  width: 120px;
  height: 120px;
  background: #de2f32;
  position: absolute;
  top: -50px;
  left: 15px;
  border-radius: 50%;
  z-index: -1;
}
.santa .head .face .redhat .redpart:before {
  content: " ";
  width: 95px;
  height: 95px;
  position: absolute;
  left: 0;
  top: 12px;
  border-radius: 50%;
  box-shadow: inset -8px -1px 0px -5px rgba(0, 0, 0, 0.05);
}
.santa .head .face .redhat .redpart:after {
  content: " ";
  position: absolute;
  right: 0;
  top: 60px;
  background: #de2f32;
  width: 20px;
  height: 50px;
}
.santa .head .face .redhat .hatball {
  width: 38px;
  height: 38px;
  background: #f8e7dc;
  border-radius: 50%;
  z-index: 5;
  position: absolute;
  right: -20px;
  top: 40px;
  box-shadow: 0px 6px 0px -4px rgba(0, 0, 0, 0.1);
}
.santa .head .face .eyes {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  top: 57px;
}
.santa .head .face .eyes:before,
.santa .head .face .eyes:after {
  content: " ";
  position: absolute;
  width: 15px;
  height: 9px;
  top: 0;
  border: 5px solid #a8744f;
  border-width: 0;
  border-top-width: 5px;
  border-radius: 50%;
}
.santa .head .face .eyes:before {
  left: -28px;
}
.santa .head .face .eyes:after {
  right: -28px;
}
.santa .head .face .beard {
  width: 55px;
  height: 55px;
  background: #f8e7dc;
  border-radius: 50%;
  position: absolute;
  bottom: -30px;
  left: 50%;
  -webkit-animation: beardLaugh 4s linear infinite;
  -moz-animation: beardLaugh 4s linear infinite;
  -ms-animation: beardLaugh 4s linear infinite;
  -o-animation: beardLaugh 4s linear infinite;
  animation: beardLaugh 4s linear infinite;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
}
.santa .head .face .beard:before,
.santa .head .face .beard:after {
  content: " ";
  width: 80px;
  height: 80px;
  background: #f8e7dc;
  border-radius: 50%;
  position: absolute;
  bottom: 15px;
}
.santa .head .face .beard:before {
  left: -40px;
}
.santa .head .face .beard:after {
  right: -40px;
}
.santa .head .face .beard .nouse {
  width: 25px;
  height: 20px;
  border-radius: 50%;
  background: #edcab0;
  position: absolute;
  z-index: 3;
  box-shadow: inset -3px -3px 0px #e9a982;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  top: -42px;
}
.santa .head .face .beard .mouth {
  background: #a8744f;
  z-index: 3;
  position: absolute;
  width: 15px;
  height: 5px;
  border-bottom-right-radius: 80px 50px;
  border-bottom-left-radius: 80px 50px;
  left: 50%;
  top: 0;
  -webkit-animation: mouthLaugh 4s linear infinite;
  -moz-animation: mouthLaugh 4s linear infinite;
  -ms-animation: mouthLaugh 4s linear infinite;
  -o-animation: mouthLaugh 4s linear infinite;
  animation: mouthLaugh 4s linear infinite;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
}
.santa .head .ears:before,
.santa .head .ears:after {
  content: " ";
  width: 20px;
  height: 30px;
  border-radius: 50%;
  background: radial-gradient(#e9a982, #edcab0);
  position: absolute;
  top: 50%;
  z-index: -1;
}
.santa .head .ears:before {
  left: -8px;
  -webkit-transform: rotate(-10deg);
  -moz-transform: rotate(-10deg);
  -ms-transform: rotate(-10deg);
  -o-transform: rotate(-10deg);
  transform: rotate(-10deg);
}
.santa .head .ears:after {
  right: -8px;
  -webkit-transform: rotate(10deg);
  -moz-transform: rotate(10deg);
  -ms-transform: rotate(10deg);
  -o-transform: rotate(10deg);
  transform: rotate(10deg);
}

@-webkit-keyframes bodyLaugh {
  0% {
    top: 0px;
  }

  2% {
    top: -3px;
  }

  4% {
    top: 0px;
  }

  8% {
    top: -3px;
  }

  10% {
    top: 0px;
  }

  12% {
    top: -3px;
  }

  14% {
    top: 0px;
  }

  18% {
    top: -3px;
  }

  20% {
    top: 0px;
  }

  22% {
    top: -3px;
  }

  24% {
    top: 0px;
  }

  28% {
    top: -3px;
  }

  30% {
    top: 0px;
  }

  100% {
    top: 0px;
  }
}
@-moz-keyframes bodyLaugh {
  0% {
    top: 0px;
  }

  2% {
    top: -3px;
  }

  4% {
    top: 0px;
  }

  8% {
    top: -3px;
  }

  10% {
    top: 0px;
  }

  12% {
    top: -3px;
  }

  14% {
    top: 0px;
  }

  18% {
    top: -3px;
  }

  20% {
    top: 0px;
  }

  22% {
    top: -3px;
  }

  24% {
    top: 0px;
  }

  28% {
    top: -3px;
  }

  30% {
    top: 0px;
  }

  100% {
    top: 0px;
  }
}
@-ms-keyframes bodyLaugh {
  0% {
    top: 0px;
  }

  2% {
    top: -3px;
  }

  4% {
    top: 0px;
  }

  8% {
    top: -3px;
  }

  10% {
    top: 0px;
  }

  12% {
    top: -3px;
  }

  14% {
    top: 0px;
  }

  18% {
    top: -3px;
  }

  20% {
    top: 0px;
  }

  22% {
    top: -3px;
  }

  24% {
    top: 0px;
  }

  28% {
    top: -3px;
  }

  30% {
    top: 0px;
  }

  100% {
    top: 0px;
  }
}
@keyframes bodyLaugh {
  0% {
    top: 0px;
  }

  2% {
    top: -3px;
  }

  4% {
    top: 0px;
  }

  8% {
    top: -3px;
  }

  10% {
    top: 0px;
  }

  12% {
    top: -3px;
  }

  14% {
    top: 0px;
  }

  18% {
    top: -3px;
  }

  20% {
    top: 0px;
  }

  22% {
    top: -3px;
  }

  24% {
    top: 0px;
  }

  28% {
    top: -3px;
  }

  30% {
    top: 0px;
  }

  100% {
    top: 0px;
  }
}
@-webkit-keyframes beardLaugh {
  0% {
    bottom: -28px;
  }

  2% {
    bottom: -30px;
  }

  4% {
    bottom: -28px;
  }

  8% {
    bottom: -30px;
  }

  10% {
    bottom: -28px;
  }

  12% {
    bottom: -30px;
  }

  14% {
    bottom: -28px;
  }

  18% {
    bottom: -30px;
  }

  20% {
    bottom: -28px;
  }

  22% {
    bottom: -30px;
  }

  24% {
    bottom: -28px;
  }

  28% {
    bottom: -30px;
  }

  30% {
    bottom: -28px;
  }

  100% {
    bottom: -28px;
  }
}
@-moz-keyframes beardLaugh {
  0% {
    bottom: -28px;
  }

  2% {
    bottom: -30px;
  }

  4% {
    bottom: -28px;
  }

  8% {
    bottom: -30px;
  }

  10% {
    bottom: -28px;
  }

  12% {
    bottom: -30px;
  }

  14% {
    bottom: -28px;
  }

  18% {
    bottom: -30px;
  }

  20% {
    bottom: -28px;
  }

  22% {
    bottom: -30px;
  }

  24% {
    bottom: -28px;
  }

  28% {
    bottom: -30px;
  }

  30% {
    bottom: -28px;
  }

  100% {
    bottom: -28px;
  }
}
@-ms-keyframes beardLaugh {
  0% {
    bottom: -28px;
  }

  2% {
    bottom: -30px;
  }

  4% {
    bottom: -28px;
  }

  8% {
    bottom: -30px;
  }

  10% {
    bottom: -28px;
  }

  12% {
    bottom: -30px;
  }

  14% {
    bottom: -28px;
  }

  18% {
    bottom: -30px;
  }

  20% {
    bottom: -28px;
  }

  22% {
    bottom: -30px;
  }

  24% {
    bottom: -28px;
  }

  28% {
    bottom: -30px;
  }

  30% {
    bottom: -28px;
  }

  100% {
    bottom: -28px;
  }
}
@keyframes beardLaugh {
  0% {
    bottom: -28px;
  }

  2% {
    bottom: -30px;
  }

  4% {
    bottom: -28px;
  }

  8% {
    bottom: -30px;
  }

  10% {
    bottom: -28px;
  }

  12% {
    bottom: -30px;
  }

  14% {
    bottom: -28px;
  }

  18% {
    bottom: -30px;
  }

  20% {
    bottom: -28px;
  }

  22% {
    bottom: -30px;
  }

  24% {
    bottom: -28px;
  }

  28% {
    bottom: -30px;
  }

  30% {
    bottom: -28px;
  }

  100% {
    bottom: -28px;
  }
}
@-webkit-keyframes headLaugh {
  0% {
    bottom: 83px;
  }

  45% {
    bottom: 83px;
  }

  50% {
    bottom: 90px;
  }

  92% {
    bottom: 90px;
  }

  98% {
    bottom: 83px;
  }

  100% {
    bottom: 83px;
  }
}
@-moz-keyframes headLaugh {
  0% {
    bottom: 83px;
  }

  45% {
    bottom: 83px;
  }

  50% {
    bottom: 90px;
  }

  92% {
    bottom: 90px;
  }

  98% {
    bottom: 83px;
  }

  100% {
    bottom: 83px;
  }
}
@-ms-keyframes headLaugh {
  0% {
    bottom: 83px;
  }

  45% {
    bottom: 83px;
  }

  50% {
    bottom: 90px;
  }

  92% {
    bottom: 90px;
  }

  98% {
    bottom: 83px;
  }

  100% {
    bottom: 83px;
  }
}
@keyframes headLaugh {
  0% {
    bottom: 83px;
  }

  45% {
    bottom: 83px;
  }

  50% {
    bottom: 90px;
  }

  92% {
    bottom: 90px;
  }

  98% {
    bottom: 83px;
  }

  100% {
    bottom: 83px;
  }
}
@-webkit-keyframes mouthLaugh {
  0% {
    width: 20px;
  }

  45% {
    width: 20px;
  }

  50% {
    width: 15px;
  }

  92% {
    width: 15px;
  }

  98% {
    width: 20px;
  }

  100% {
    width: 20px;
  }
}
@-moz-keyframes mouthLaugh {
  0% {
    width: 20px;
  }

  45% {
    width: 20px;
  }

  50% {
    width: 15px;
  }

  92% {
    width: 15px;
  }

  98% {
    width: 20px;
  }

  100% {
    width: 20px;
  }
}
@-ms-keyframes mouthLaugh {
  0% {
    width: 20px;
  }

  45% {
    width: 20px;
  }

  50% {
    width: 15px;
  }

  92% {
    width: 15px;
  }

  98% {
    width: 20px;
  }

  100% {
    width: 20px;
  }
}
@keyframes mouthLaugh {
  0% {
    width: 20px;
  }

  45% {
    width: 20px;
  }

  50% {
    width: 15px;
  }

  92% {
    width: 15px;
  }

  98% {
    width: 20px;
  }

  100% {
    width: 20px;
  }
}
</style>